import { FileVersion } from "../../store/models/fileVersion";
import {
  makeBackendGetCallWithJsonResponse,
  makeBackendPostCallWithJsonResponse,
} from "../../store/utils/fetch";
import { FETCH_TRACK, FETCH_TRACK_SNIPPET } from "../../store/utils/routes";

export interface DownloadTrackByPathParams {
  isSnippet?: boolean;
  params: string;
}

const downloadTrackByPath = async ({
  isSnippet = false,
  params,
}: DownloadTrackByPathParams) => {
  const response = await makeBackendGetCallWithJsonResponse<{
    url: string;
    content_type: string;
    waveform_peaks?: string;
    duration?: number;
  }>(isSnippet ? FETCH_TRACK_SNIPPET : FETCH_TRACK, params);

  if (response.success) {
    return response.resultJson;
  }
  return Promise.reject(response.resultJson);
};

export interface UpdateWaveformPeaksForTrackByPathParams {
  isSnippet?: boolean;
  fileVersionId: number;
  useGeneratedMP3?: boolean;
  projectId?: number;
  useRef?: boolean;
  waveformPeaks: string;
  duration: number;
}

const updateWaveformPeaksForDownloadedTrack = async ({
  isSnippet = false,
  fileVersionId,
  useGeneratedMP3,
  projectId,
  useRef,
  waveformPeaks = "",
  duration,
}: UpdateWaveformPeaksForTrackByPathParams) => {
  const response = await makeBackendPostCallWithJsonResponse<FileVersion>(
    isSnippet ? FETCH_TRACK_SNIPPET : FETCH_TRACK,
    {
      file_version_id: fileVersionId,
      project_id: projectId,
      use_ref: useRef,
      waveform_peaks: waveformPeaks,
      duration: duration,
      use_generated_mp3: useGeneratedMP3,
    },
  );

  if (response.success) {
    return response.resultJson;
  }
  return Promise.reject(response.resultJson);
};

export { downloadTrackByPath, updateWaveformPeaksForDownloadedTrack };
